import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TeamQueueInformation } from '../../../../models/team/team-queue-information.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-manage-queue-information',
  templateUrl: './manage-queue-information.component.html',
  styleUrls: ['./manage-queue-information.component.css'],
  imports: [
    CommonModule
  ]
})
export class ManageQueueInformationComponent implements OnInit, OnChanges {
  @Input() model: TeamQueueInformation;

  constructor() {
  }
  
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("Received OnChanges for ManageQueueInformation");

    for (let propName in changes)
      this.model = changes[propName].currentValue;
  }
}
